export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_1280000-dd9f7ec37644185ff0b1167312bb2881.avif";